"use client"
import { Skeleton } from "@/app/ui/imported/skeleton";
import Spinner from "@/app/ui/utils/Spinner";
import { cn, GoogleAnalyticsEvent } from "@/lib/utils";
import { Session } from "next-auth";
import { signIn, signOut, useSession } from "next-auth/react";
import Image from "next/image";
import { usePathname, useRouter } from 'next/navigation';
import { useState } from "react";
import Button from "../../ui/forms/ButtonNF";


export default function UserWidgetClient() {
    const session = useSession()
    const isLoggedIn = session.status == "authenticated"; // convert to boolean
    const isLoggedOut = session.status == "unauthenticated";
    const sessionLoading = session.status == "loading";
    const pathname = usePathname();

    return (
        <div className={ `dynMenu flex items-center mb-2 sm:mb-0 ${pathname.startsWith("/login") && "invisible pointer-events-none transition-none" || ""}` } >
            { sessionLoading && <Skeleton className=""><LoginButton className="invisible px-8 py-2" /></Skeleton> }

            { isLoggedOut && <LoginButton /> }
            { isLoggedIn && <UserSnippet session={ session.data } /> }
        </div >
    )
}

function LoginButton({ className }: { className?: string }) {
    return <Button color="nfBlue" className={ cn("relative", className) } onClick={ () => {
        GoogleAnalyticsEvent({ event_name: "login", event_value: undefined });
        signIn("discord");
    }
    }>
        <svg className="h-1em w-fit" xmlns="http://www.w3.org/2000/svg"
            width="800px" height="800px" viewBox="0 -28.5 256 256" version="1.1" preserveAspectRatio="xMidYMid" >
            <g>
                <path
                    d="M216.856339,16.5966031 C200.285002,8.84328665 182.566144,3.2084988 164.041564,0 C161.766523,4.11318106 159.108624,9.64549908 157.276099,14.0464379 C137.583995,11.0849896 118.072967,11.0849896 98.7430163,14.0464379 C96.9108417,9.64549908 94.1925838,4.11318106 91.8971895,0 C73.3526068,3.2084988 55.6133949,8.86399117 39.0420583,16.6376612 C5.61752293,67.146514 -3.4433191,116.400813 1.08711069,164.955721 C23.2560196,181.510915 44.7403634,191.567697 65.8621325,198.148576 C71.0772151,190.971126 75.7283628,183.341335 79.7352139,175.300261 C72.104019,172.400575 64.7949724,168.822202 57.8887866,164.667963 C59.7209612,163.310589 61.5131304,161.891452 63.2445898,160.431257 C105.36741,180.133187 151.134928,180.133187 192.754523,160.431257 C194.506336,161.891452 196.298154,163.310589 198.110326,164.667963 C191.183787,168.842556 183.854737,172.420929 176.223542,175.320965 C180.230393,183.341335 184.861538,190.991831 190.096624,198.16893 C211.238746,191.588051 232.743023,181.531619 254.911949,164.955721 C260.227747,108.668201 245.831087,59.8662432 216.856339,16.5966031 Z M85.4738752,135.09489 C72.8290281,135.09489 62.4592217,123.290155 62.4592217,108.914901 C62.4592217,94.5396472 72.607595,82.7145587 85.4738752,82.7145587 C98.3405064,82.7145587 108.709962,94.5189427 108.488529,108.914901 C108.508531,123.290155 98.3405064,135.09489 85.4738752,135.09489 Z M170.525237,135.09489 C157.88039,135.09489 147.510584,123.290155 147.510584,108.914901 C147.510584,94.5396472 157.658606,82.7145587 170.525237,82.7145587 C183.391518,82.7145587 193.761324,94.5189427 193.539891,108.914901 C193.539891,123.290155 183.391518,135.09489 170.525237,135.09489 Z"
                    fill="#fff" fillRule="nonzero">
                </path>
            </g>
        </svg >
        <span className="d">
            התחבר
        </span>
    </Button>
}

function UserSnippet({ session }: { session: Session }) {
    const { user } = session;
    if (!user)
        throw new Error("Attempt to render user data for non-logged in user")

    const [loggingOut, setLoggingOut] = useState(false);
    const router = useRouter();

    async function logoutAction(e: any) {
        e.preventDefault();
        if (loggingOut)
            return;
        setLoggingOut(true)
        await signOut({ "callbackUrl": "/" }); //call server action for logout
        router.push("/")
    }

    const size = 48;

    return <article className="flex gap-3 items-center text-sm py-1 px-1 rounded  lg:rounded-e-lg lg:rounded-s-[30px] bg-nfPurple-500/50">
        <Image className="rounded-full sm:hidden lg:block  w-12 h-12" src={ user.image || "" } width={ size } height={ size } alt={ user.name || "" }
            quality={ 100 } blurDataURL={ user.image + "?size=16" || "" } placeholder="blur" priority />
        <div className="flex flex-col items-center w-min text-lg leading-normal sm:text-[max(min(1em,1.2vw),0.7rem)] max-w-[80vw] sm:max-w-[12ch] lg:max-w-[20ch]">
            <span className="truncate max-w-[inherit]">{ user.name }</span>
            <form onSubmit={ logoutAction } className="w-60 sm:w-full text-center">
                <Button color="red" className={ `w-full leading-none py-0 px-0 ${loggingOut && "bg-gray-400/40 outline-0 pointer-events-none" || "bg-red-800/20 outline-1"}` } disabled={ loggingOut }>
                    { loggingOut && <Spinner className="text-nfBlue-400" /> || <>התנתק</> }
                </Button>
            </form>
        </div>
    </article >
}